export const isSelectionInside = (view, node) => {
    if (!view.hasFocus)
        return false;
    return view.state.selection.ranges.some((range) => {
        return range.from <= node.to && range.to >= node.from;
    });
};
